import type { TaskResult } from "../types";

export async function gradeProject3(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Validación de datos tipo lista en C6:C15
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem(
      "Inscripciones Escuela de Esquí"
    );
    const rangoNotas = ws.getRange("C6:C15");
    rangoNotas.load("rowCount");
    await context.sync();

    const celdas: Excel.Range[] = [];
    for (let i = 0; i < rangoNotas.rowCount; i++) {
      const celda = rangoNotas.getCell(i, 0);
      celda.load("dataValidation/type,dataValidation/rule");
      celdas.push(celda);
    }
    await context.sync();

    const norm = (s = "") => s.replace(/\$/g, "").toUpperCase();
    const origenLista = "=E6:E9";

    const passed = celdas.every((c) => {
      if (c.dataValidation.type !== Excel.DataValidationType.list) return false;
      const regla = c.dataValidation.rule?.list;
      if (!regla || !regla.source || typeof regla.source !== "string") return false;
      return norm(regla.source as string) === norm(origenLista);
    });

    results.push({ taskId: 1, passed });
  });

  // Tarea 2: SUMAR.SI.CONJUNTO en O3 → 4991
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem(
      "Precios de Esquí en Utah"
    );
    const celda = hoja.getRange("O3");
    celda.load("values");
    await context.sync();
    results.push({ taskId: 2, passed: celda.values[0][0] === 4991 });
  });

  // Tarea 3: PROMEDIO.SI.CONJUNTO en L3 → 1129.5
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem(
      "Precios de Esquí en Utah"
    );
    const celda = hoja.getRange("L3");
    celda.load("values");
    await context.sync();
    results.push({ taskId: 3, passed: celda.values[0][0] === 1129.5 });
  });

  // Tarea 4: Verificar que el modo de cálculo es manual
  await Excel.run(async (context) => {
    const app = context.workbook.application;
    app.load("calculationMode");
    await context.sync();

    const passed = app.calculationMode === Excel.CalculationMode.manual;
    results.push({ taskId: 4, passed });
  });

  // Tarea 5: Gráfico combinado — área con "Pase anual de adultos" y línea con "Pase anual de niños"
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem(
      "Precios de Esquí en Utah"
    );
    const charts = hoja.charts;
    charts.load("items");
    await context.sync();

    const areaTypes = ["area", "areastacked", "areastacked100"];
    const lineTypes = ["line", "linestacked", "linestacked100", "linemarkers",
      "linemarkersstacked", "linemarkersstacked100"];

    let passed = false;

    for (const chart of charts.items) {
      const series = chart.series;
      series.load("items/chartType,items/name");
      await context.sync();

      let adultosArea = false;
      let ninosLine = false;

      for (const s of series.items) {
        const tipo = (s.chartType || "").toLowerCase().trim();
        const nombre = (s.name || "").toLowerCase().trim();

        // Must contain "anual" to distinguish from "Pase de un día"
        const esAnualAdultos = nombre.includes("anual") && nombre.includes("adultos");
        const esAnualNinos = nombre.includes("anual") && (nombre.includes("niño") || nombre.includes("nino"));

        if (esAnualAdultos && areaTypes.includes(tipo)) adultosArea = true;
        if (esAnualNinos && lineTypes.includes(tipo)) ninosLine = true;
      }

      if (adultosArea && ninosLine) {
        passed = true;
        break;
      }
    }

    results.push({ taskId: 5, passed });
  });

  return results;
}
